import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  max-width: 1360px !important;
  min-width: 633px !important;
`

export const MainContainer = styled.div`
  gap: ${props => props.theme.spacing.sp32};
  display: grid;
  grid-template-columns: 60% calc(40% - ${props => props.theme.spacing.sp32});

  @media screen and (max-width: 1163px) {
    grid-template-columns: 100%;
  }
`

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const NavRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NavContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderOptions = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HeaderOptionsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderActions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const StatusSteps = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`

export const StatusStep = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  flex: 1;
`

export const InfoBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const LineItem = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1;
`

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const CommentRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const CommentInput = styled.div`
  flex: 1;
`

export const TimelineEvents = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TimelineEvent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
`

export const TimelineEventText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const CostRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
